module.exports = __webpack_public_path__ + "images/rank-gains-e0492722.svg";